export default "__VITE_ASSET__Bvgw6X8H__"